import React from 'react';

import RichTextEditorContent from '../../RichTextEditor/components/RichTextEditorContent';

import styles from './EventDescription.module.scss';

const eventClassNames = {
  container: styles.mainSection,
  title: styles.title,
  subtitle: styles.subtitle,
  sectionTitle: styles.sectionTitle,
  paragraph: styles.description,
  emphasis: styles.emphasize,
  citation: styles.citation,
  imageSection: styles.mainImageSection,
  imageSectionSmall: styles.mainImageSectionSmall,
  image: styles.mainImage,
  imageCaption: styles.mainImageCredit,
};

const EventDescriptionRichTextEditor = ({
  setState,
  state,
  contentEditable,
}) => {
  return (
    <RichTextEditorContent
      state={state}
      setState={setState}
      contentEditable={contentEditable}
      classNames={eventClassNames}
    />
  );
};

export default EventDescriptionRichTextEditor;
